import React from "react";
import ReportLayout from "../../layouts/ReportLayout";
import {
    CuTableHeader,
    CuTableRow,
    CuTableSN,
    CuTableColumn,
    CuTableHead,
    CuTableBody,
    CuReportTable,
} from "../../../components/Tables/ReportTableComp";
import { isEmpty } from "lodash";
import moment from "moment";
import ReportNoData from "../../../components/ReportNoData";

const TrainingReport = ({ trainings }) => {
    return (
        <ReportLayout
            head={"Wazawa Max organization report"}
            orientation={"landscape"}
        >
            {isEmpty(trainings) ? (
                <>
                    <ReportNoData />
                </>
            ) : (
                <CuReportTable>
                    <CuTableHeader>
                        <CuTableRow>
                            <CuTableSN value={"S/N"} />
                            <CuTableHead value={"Training"} />
                            <CuTableHead
                                value={"Region"}
                                style={{
                                    width: "230px",
                                    textAlign: "center",
                                }}
                            />
                            <CuTableHead
                                value={"Posted"}
                                style={{
                                    width: "300px",
                                }}
                            />
                            <CuTableHead
                                value={"status"}
                                style={{
                                    width: "200px",
                                    textAlign: "center",
                                }}
                            />
                        </CuTableRow>
                    </CuTableHeader>
                    {/* Table body */}
                    <CuTableBody>
                        {trainings.map((training, index) => (
                            <CuTableRow key={index}>
                                <CuTableSN value={++index} />
                                <CuTableColumn value={training.title} />
                                <CuTableColumn
                                    value={training.region}
                                    style={{
                                        width: "230px",
                                        textAlign: "center",
                                    }}
                                />
                                <CuTableColumn
                                    value={moment(training.created_at).format(
                                        "LL"
                                    )}
                                    style={{
                                        width: "300px",
                                    }}
                                />
                                <CuTableColumn
                                    value={training.status}
                                    style={{
                                        width: "200px",
                                        whiteSpace: "nowrap",
                                        textAlign: "center",
                                        color:
                                            training.status === "draft"
                                                ? "brown"
                                                : training.status ===
                                                  "published"
                                                ? "green"
                                                : training.status ===
                                                      "suspended" ||
                                                  training.status === "expired"
                                                ? "red"
                                                : training.status === "closed"
                                                ? "brown"
                                                : "black",
                                    }}
                                />
                            </CuTableRow>
                        ))}
                    </CuTableBody>
                </CuReportTable>
            )}
        </ReportLayout>
    );
};

export default TrainingReport;
